import $ from 'jquery';

export default class ReviewCarousel {
    constructor() {
        $('.review-carousel__slick').slick({
            arrows: true,
            prevArrow:"<img class='slick-arrow slick-prev' src='../../wp-content/themes/york-test/resources/icons/arrow-left.png' alt='Click to slide left'>",
            nextArrow:"<img class='slick-arrow slick-next' src='../../wp-content/themes/york-test/resources/icons/arrow-right.png' alt='Click to slide right'>",
            centerMode: true,
            slidesToShow: 1,
            centerPadding: '5%',
            slidesToScroll: 1,
            autoplay: true,
            dots: true,
            autoplaySpeed: 8000,
            mobileFirst: false,
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerPadding: '5%'
                }
            }, {
                breakpoint: 99999,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerPadding: '24%'
                }
            }]
        }).slick('resize');
    }
}

new ReviewCarousel();
